import React from 'react'

export default function updateuser() {
  return (
    <div>updateuser</div>
  )
}
